import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {

  // endpoint is /api/estimate-options/ and can be filtered by ?estimate=123 or ?option_selection=Y or ?include_in_price=false
  
  async getEstimateOptions (estimateID) {
    return axios.get(endpoints.estimateOptions + '?estimate=' + estimateID).then((response) => {
      return response.data
    })
  },
  async createEstimateOption (option) {
    return axios.post(endpoints.estimateOptions, option).then((response) => {
      return response.data
    })
  },
  async updateEstimateOption (option) {
    return axios.patch(endpoints.estimateOptions + option.id + '/', option).then((response) => {
      return response.data
    })
  },
  async deleteEstimateOption (option) {
    return axios.delete(endpoints.estimateOptions + option.id + '/').then((response) => {
      return response.data
    })
  }
}